import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {forkJoin, Observable, Subject} from 'rxjs';
import {map, switchMap, tap} from 'rxjs/operators';

import {
  ChacraGeo,
  ChacraGeoService,
} from '../../../../../chacra-core';
import * as chacrasGeoActions from './chacras-geo.actions';

import {NotificationService} from '../../../../../core/services';
import {LocalStorageService} from '../../../../../core/services';
import {AUTH_ROLE_ID} from '../../../../../core';
import {QueryResultApi} from "../../../../../shared/models";

@Injectable()
export class ChacrasGeoEffects {

  // load
  ChacrasLoadGeoRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<chacrasGeoActions.ChacrasGeoLoadRequestAction>(
      chacrasGeoActions.ChacrasGeoActionTypes.CHACRAS_GEO_LOAD_REQUEST
    ),
    switchMap((action) => {

      const sub: Subject<Action> = new Subject<Action>();

      const rolId = this.localStorageService.getItem(AUTH_ROLE_ID);
      let params: any = {rolId};

      const requestObservers = [];
      for (let from of action.from) {
        requestObservers.push(this.chacrasGeoService.getGeo(from, params));
      }

      forkJoin(requestObservers).subscribe((results: QueryResultApi<ChacraGeo>[]) => {
          let items = [];
          for (let result of results) {
            items = [...items, ...result.items]
          }

          let actionDispatch: Action = new chacrasGeoActions.ChacrasGeoLoadSuccessAction({
            items
          });

          sub.next(actionDispatch);
          sub.complete();
        },
        (error => {
          const actionDispatch = new chacrasGeoActions.ChacrasGeoLoadFailureAction({error});
          sub.next(actionDispatch);
          sub.complete();
        })
      );
      return sub;
    })
  ));

  ChacrasGeoFailureEffect$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(
      chacrasGeoActions.ChacrasGeoActionTypes.CHACRAS_GEO_LOAD_FAILURE,
    ),
    map(
      (
        action:
          | chacrasGeoActions.ChacrasGeoLoadFailureAction
      ) => action.payload.error
    ),
    tap((error: string) => this.notificationService.error(error))
  ), {dispatch: false});

  // error

  constructor(
    private notificationService: NotificationService,
    private chacrasGeoService: ChacraGeoService,
    private actions$: Actions,
    private localStorageService: LocalStorageService
  ) {
  }
}
